import { TABLE_PAGE_SIZE_OPTIONS } from '@/constants';

// Raw localStorage rather than the Zustand persist store, keyed like the studies-list table
// (Studies/components/TableData.tsx) — per-table furniture, not a preference the app reads elsewhere.
export const PAGE_SIZE_STORAGE_KEY = 'instruments-table-pageSize';
export const DEFAULT_PAGE_SIZE = 25;

// Membership in TABLE_PAGE_SIZE_OPTIONS is what AG Grid requires of paginationPageSize, so a stale
// value from an older options array degrades to the default rather than desyncing the selector.
export const readStoredPageSize = (): number => {
  try {
    const stored = Number.parseInt(localStorage.getItem(PAGE_SIZE_STORAGE_KEY) ?? '', 10);
    return TABLE_PAGE_SIZE_OPTIONS.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
  } catch {
    // Ignore storage errors (private browsing, quota exceeded, etc.)
    return DEFAULT_PAGE_SIZE;
  }
};

export const writeStoredPageSize = (pageSize: number): void => {
  try {
    localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(pageSize));
  } catch {
    // Ignore storage errors (private browsing, quota exceeded, etc.)
  }
};
